const Index = () =>
    import("@view/yili/index");
const Bilibli = () =>
    import("@view/bilibili/index");
const Casebilibili = () =>
    import("@view/bilibili/casebilibili");
const Casebilibilipc = () =>
    import("@view/bilibili/components/index");
const Casebilibilipcdetails = () =>
    import("@view/bilibili/components/casealldetails");
const Caseeducation = () =>
    import("@view/caseeducation/index");
const Caseeducationpc = () =>
    import("@view/caseeducation/components/index");
const Caseeducationdetails = () =>
    import("@view/caseeducation/casebilibili");
const Caseeducationpcdetails = () =>
    import("@view/caseeducation/components/casealldetails");
const routes = [
    {
        path: '/',
        redirect: '/casebrands'
    },
    {
        path: "/index",
        component: Index,
        meta: {
            title: "随幻科技案例中心"
        }
    },
    {
        path: "/casebilibili",
        component: Casebilibili,
        meta: {
            title: "随幻科技品牌案例中心"
        }
    },
    {
        path: "/Casebilibilipcdetails",
        component: Casebilibilipcdetails,
        meta: {
            title: "随幻科技品牌案例中心"
        }
    },
    {
        path: "/casebrands",
        component: Casebilibilipc,
        meta: {
            title: "随幻科技品牌案例中心"
        }
    },
    {
        path: "/casebrands/index",
        component: Bilibli,
        meta: {
            title: "随幻科技品牌案例中心"
        },
    },
    {
        path: "/caseeducation",
        component: Caseeducationpc,
        meta: {
            title: "随幻科技院校案例中心"
        }
    },
    {
        path: "/caseeducation/index",
        component: Caseeducation,
        meta: {
            title: "随幻科技院校案例中心"
        },
    },
    {
        path: "/caseeducation/details",
        component: Caseeducationpcdetails,
        meta: {
            title: "随幻科技院校案例中心"
        }
    },
    {
        path: "/caseeducation/index/details",
        component: Caseeducationdetails,
        meta: {
            title: "随幻科技院校案例中心"
        },
    },
];

export default routes;
